import {uniqueId} from 'lodash'
import {PROSPECT_SERVICE_PROVIDER, ACTIVE_SERVICE_PROVIDER} from '../serviseProvider'

const routeToVendor = {
  name: 'ContactServiceProvider',
  params: {
    id: 'id',
    contactType: 3
  },
  paramName: 'id',
  paramValue: 'id',
  props: true
}

const columns = [
  {
    title: 'VENDORS',
    sort: true,
    route: routeToVendor,
    prop: 'companyName',
  },
  {
    title: 'SERVICES / GOODS',
    prop: 'services',
    isHavePrompt: true,
    propPrompt: 'details',
  },
  {
    title: 'TAGS',
    prop: 'vendorTags',
    type: 'tagCell',
    width: 'minmax(80px, auto)'
  },
  {
    title: '',
    type: 'copy',
    prop: 'email',
    width: '52px',
  },
  {
    title: 'EMAIL',
    prop: 'email',
  },
  {
    title: '',
    type: 'copy',
    prop: 'phone',
    width: '52px',
  },
  {
    title: 'TEL',
    prop: 'phone',
    width: '160px',
  },
  {
    title: 'RATING',
    type: 'rating',
    prop: 'rating',
    width: '85px',
  },
  {
    type: 'toolbar',
    width: '52px'
  }
]

const prefix = 'logs_column_'
const serviceProviderTableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  return col
})

export default serviceProviderTableColumns



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/serviceProviderTable.js